import script from "./PartnerDocument.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerDocument.vue?vue&type=script&setup=true&lang=js"

import "./PartnerDocument.vue?vue&type=style&index=0&id=73e6a6de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73e6a6de"]])

export default __exports__